<script>
import text from './Text'
import location from './Location'
import attachment from './Attachment'
import giphy from './Giphy'
import voice from './Voice'
import unsupported from './Unsupported'

const typeContentComponent = {
  'm.text': text,
  'm.notice': text,
  'm.location': location,
  'm.image': attachment,
  'm.video': attachment,
  'm.audio': voice,
  'm.file': attachment,
  'm.gif': giphy
}

export default {
  name: 'MessageContentMatrix',
  functional: true,
  render (h, { data, props }) {
    const { msgtype } = props.message.content
    const component = typeContentComponent[msgtype] || unsupported
    return h(component, { ...data, ...props })
  }
}
</script>
